function Triangle(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M240 60 32.2 420h415.7L240 60z"></path></svg>
    )
}

export default Triangle